import { useState, useContext, useEffect } from "react";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { EventContext } from "../../../contexts/EventContext";
import { MessengerContext } from "../../../contexts/MessengerContext";


const Recipients = () => {
  const { attendees } = useContext(EventContext);
  const {recipients, setRecipients} = useContext(MessengerContext);



  const handleChange = (e) => {
    setRecipients(e.target.value);
  };

  return (
    <FormControl style={{ width: 300 }} size="small">
      <InputLabel id="label">Recipients</InputLabel>
      <Select
        labelId="label"
        multiple
        value={recipients}
        onChange={handleChange}
        renderValue={(selected) =>
          selected
            .map((id) => {
              const attendee = attendees.find((a) => a._id === id);
              return attendee
                ? `${attendee.profile.firstName} ${attendee.profile.lastName}`
                : id;
            })
            .join(", ")
        }
      >
        {attendees.map((attendee) => {
          return (
            <MenuItem key={attendee._id} value={attendee._id}>
              {attendee?.profile?.firstName} {attendee?.profile?.lastName}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default Recipients;
